import Nullstack from 'nullstack';
export default function IconIcons({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-icons",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "3.5"
  }), "   ", Nullstack.element("path", {
    d: "M2.5 21h8l-4 -7z"
  }), "   ", Nullstack.element("path", {
    d: "M14 3l7 7"
  }), "   ", Nullstack.element("path", {
    d: "M14 10l7 -7"
  }), "   ", Nullstack.element("path", {
    d: "M14 14h7v7h-7z"
  }), " ");
}